export default{
  // 卡片标题和文字
  'overview_weekly_Weekly': '运营总况周报',
  'overview_weekly_avgWAU': '周平均活跃',
  'overview_weekly_WAU': '周活跃',

  'overview_weekly_W2(T-1)': '次周留存(T-1)',

  'overview_weekly_W2/3': '次周留存/3周留存', // 18

  'overview_weekly_WAU_This_Week': '本周活跃', // 22
  'overview_weekly_WAU_Last_Month': '上月同期活跃', // 23

  'overview_weekly_Revenue($)_This_Week': '本周付费金额', // 30
  'overview_weekly_Revenue($)_Last_Month': '上月同期付费金额', // 31

  // 卡片
  'overview_weekly_key_performance_metrics_explain_au': '统计周期内登录过游戏的用户数(vopenid数去重)，超过一周展示平均周活跃。',
  'overview_weekly_key_performance_metrics_explain_new': '统计周期内新注册用户数(vopenid数去重)，超过一周展示累计新进。',
  'overview_weekly_key_performance_metrics_explain_revenue': '统计周期内玩家的实际付费金额总额，超过一天展示累计付费。',
  'overview_weekly_key_performance_metrics_explain_arpu': '活跃ARPU=统计周期内消费额/活跃用户数。<br/>超过一周展示平均ARPU。统计周期内消费额的和/活跃用户数的和。',
  'overview_weekly_key_performance_metrics_explain_payer': '付费渗透率=统计周期内消费用户数/活跃用户数<br/>超过一周展示平均付费渗透率。统计周期内消费用户数的和/活跃用户数的和。',
  'overview_weekly_key_performance_metrics_explain_w2': '前一周次留，次周留存=XX注册日期第2周存留用户数/XX注册周新注册用户数，注册周是第一周。<br/>超过一周展示平均次周留存，统计周期内每一周注册用户次留用户数求和/统计周期内每一周新注册用户数求和。',

  // Overall Performance 宽表

  'overview_weekly_Avg.Daily_New': '平均每日新进用户数',
  'overview_weekly_Week_Avg.DAU': '周平均日活跃',
  'overview_weekly_Week_Avg.Revenue($)': '周平均付费金额({unit})',

  'overview_weekly_W2': '次周留存',
  'overview_weekly_W3': '3周留存',
  'overview_weekly_W4': '4周留存',

  'overview_weekly_WAU_Retention_Users': '周活留存',

  'overview_weekly_weighted_tab': '加权次周留存/3周留存',
  'overview_weekly_WAU_Return_Users': '周回流',
  'overview_weekly_avg_dau': '周平均DAU',
  'overview_weekly_Weighted_W2': '加权次周留存',
  'overview_weekly_Weighted_W3': '加权3周留存',
  'overview_weekly_Weighted_W4': '加权4周留存',
  'overview_weekly_Weighted_W2_short': '加权次周留存',
  'overview_weekly_Weighted_W3_short': '加权3周留存',
  'overview_weekly_Weighted_W4_short': '加权4周留存',

  // WAU Breakdown 图表模块
  'overview_weekly_WAU_Breakdown': '周活跃构成', // 1


  'overview_weekly_WAU_of_Top_10_Countries': '周活跃用户 Top 10 国家', // 5
  'overview_weekly_WAU_of_Top_10_Zone': '周活跃用户 Top 10 区服', // 5
  'overview_weekly_WAU_of_Top_10_Region': '周活跃用户 Top 10 区域', // 5
  'overview_weekly_Avg.WAU': '周平均活跃', // 6


  // 待补充
  'overview_week_retention_2': '次周留存',
  'overview_week_retention_3': '3周留存',
  'overview_week_Weighted_2': '加权次周留存',
  'overview_week_Weighted_3': '加权3周留存',
  'overview_week_retention_7': '7周留存',
  'overview_weekly_Last_Week': '上周同期',
  'overview_weekly_Today': '当天',
  'overview_weekly_Last_Month': '上月同期',
  'overview_weekly_This_Week': '当周',
  'overview_weekly_Last_Year': '去年同期',
  'overview_weekly_This_Month': '当月',
  'overview_weekly_New': '新进用户',

}
